import Vue from 'vue'
import { Button } from 'iview'

Vue.component('Button', Button)

import 'iview/dist/styles/iview.css'
